import womenNycLogoBlack from "../assets/women.nyc-powered-by-black.png";
import womenNycLogoWhite from "../assets/women.nyc-powered-by.png";
import womenNycMenuLogo from "../assets/women-nyc-logo-white.png";
import { useSelector } from "react-redux";
import { getCurrentTheme } from "../theme";
import { RootState } from "../store/store";
import { tenantAssetUrl } from "../utils/tenantAssetUrl";

const WERULE_AUTH_LOGO_URL =
  "https://images.squarespace-cdn.com/content/v1/55e798a6e4b06629f7c5be2f/6d319b57-de6a-4edf-9f93-c073b2efa3d7/werule+new+logo.png?format=1500w";

function tenantAuthLogoSrc(): string | null {
  const { logo512, logo192 } = getCurrentTheme();
  if (logo512?.startsWith("/tenants/")) return logo512;
  if (logo192?.startsWith("/tenants/")) return logo192;
  return null;
}

function tenantHeaderLogoSrc(): string | null {
  const { logoHeader, logo512 } = getCurrentTheme();
  if (logoHeader?.startsWith("/tenants/")) return logoHeader;
  if (logo512?.startsWith("/tenants/")) return logo512;
  return tenantAuthLogoSrc();
}

function isTenantLogoSrc(src: string): boolean {
  return src.startsWith("/tenants/");
}

type LogoVariant = "auth" | "header" | "footer" | "default";

type LogoProps = {
  type?: string;
  /** Optional max-width override in pixels (legacy prop). */
  size?: number;
  style?: React.CSSProperties;
  variant?: LogoVariant;
};

export const Logo = ({ type = "main", size, style, variant = "default" }: LogoProps) => {
  const brandingAssetVersion = useSelector(
    (state: RootState) => state.config.brandingAssetVersion
  );

  let logo: string = WERULE_AUTH_LOGO_URL;
  switch (type) {
    case "women-nyc-white":
      logo = womenNycLogoWhite;
      break;
    case "women-nyc-black":
      logo = womenNycLogoBlack;
      break;
    case "women-nyc-menu":
      logo = womenNycMenuLogo;
      break;
    case "main":
    case "werule-powered-by":
      logo = WERULE_AUTH_LOGO_URL;
      break;
    case "tenant-brand":
      logo = variant === "header"
        ? (tenantHeaderLogoSrc() ?? WERULE_AUTH_LOGO_URL)
        : (tenantAuthLogoSrc() ?? WERULE_AUTH_LOGO_URL);
      break;
    default:
      logo = WERULE_AUTH_LOGO_URL;
  }

  const tenantLogo = isTenantLogoSrc(logo);
  const logoSrc = tenantLogo
    ? tenantAssetUrl(logo, brandingAssetVersion)
    : logo;
  const useTenantHeaderLayout = tenantLogo && variant === "header";

  return (
    <div
      className={[
        "own-logo",
        `own-logo--${variant}`,
        tenantLogo ? "own-logo--tenant" : "",
        useTenantHeaderLayout ? "own-logo--header-horizontal" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <img
        width={size || 200}
        src={logoSrc}
        alt="logo"
        style={style}
      />
    </div>
  );
};
